/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

// Material UI table
import { MaterialReactTable } from "material-react-table";
//Material UI components for rendring menu and others
import { MenuItem } from "@mui/material";

// import CRMProceessData from "../../../../data/CRM/CRMProcessData.json";
import CRMProcessHeader from "../CRMProcessHeader/CRMProcessHeader";
// import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import { crmCommonHeaderLinkLists } from "helper/CrmHelper/CrmHelper";
import { assetImages } from "constants";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";

import { useTranslation } from "react-i18next";
import AddProcessFromTemplateModal from "components/Common/Modal/AddProcessFromTemplateModal";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import ActivityProcessFilter from "components/Common/Popup/ActivityProcessFilter";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";

const CRMProcessBody = () => {
  /* ------------- Language translation imports starts here ------------- */
  const { t, i18n } = useTranslation();
  // common header object
  const commonHeaderObject = crmCommonHeaderLinkLists(t);
  const token = localStorage.getItem("token");
  const moduleAccess = localStorage.getItem("moduleaccess");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [isLoading, setisLoading] = useState(false);
  const [processList, setprocessList] = useState([]);

  const [isDataReady, setIsDataReady] = useState(false);

  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  // json filter query — starts as null so we can distinguish
  // "not yet decided" vs "decided: no filter"
  // null   = filter popup hasn't told us what to do yet (skip API call)
  // []     = filter popup said: no default filter, fetch all
  // [...]  = filter popup said: use these filters
  const [jsonFilterQuery, setJsonFilterQuery] = useState(null);

  //optionally, you can manage the row selection state yourself
  const [rowSelection, setRowSelection] = useState({});
  const [selectProcessIds, setSelectProcessIds] = useState([]);

  //alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [lastPagination, setLastPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const getAllProcess = async (filterQuery = []) => {
    try {
      setisLoading(true);

      let requestURL =
        url.API_BASE_URL +
        url.API_GET_ALL_PROCESS +
        `?ismod=${true}&istemplate=${false}`;

      if (filterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = filterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestURL += `&filters=${JSON.stringify(sanitizedQuery)}`;
      }

      console.log(requestURL);

      const response = await getData(requestURL);

      setisLoading(false);
      console.log("response process----->", response);

      if (response.status) {
        setMessageType("success");
        setprocessList(response.data);
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }

    setShowAlert(true);
  };

  //function for change status = 0
  const changeStatusHandler = async () => {
    if (selectProcessIds.length > 0) {
      let responseArr = [];

      for (let processId of selectProcessIds) {
        try {
          let tagData = {
            status: "0",
          };
          let requestUrl =
            url.API_BASE_URL +
            url.API_UPDATE_PROCESS +
            `/${processId}` +
            ``;

          const response = await putData(requestUrl, tagData);

          if (response.status) {
            setMessageType("success");
            responseArr.push(true);
          } else {
            setMessageType("error");
          }

          setAlertMessage(response.message);
        } catch (error) {
          setMessageType("error");
          setAlertMessage(error.message);
        }

        setShowAlert(true);
      }

      if (responseArr.length > 0) {
        setTimeout(() => {
          getAllProcess();
        }, 2200);
      }
    } else {
      setMessageType("error");
      setAlertMessage("Please select process for delete");
      setShowAlert(true);
    }
  };

  const initialTableColumns = [
    {
      accessorKey: "#",
      header: t("Actions"),
      Cell: ({ row }) => (
        <Link
          to={`/admin/crm/process/save/${row.original._id}`}
          className="action_btn_mui"
          aria-controls="addTask_view"
        >
          <span className="d-block material-symbols-outlined horz_icon">
            more_horiz
          </span>
        </Link>
      ),
      enableColumnActions: false, // Hides the column action icon
      enableColumnDragging: false, // Hides the move icon
      enableSorting: false,
    },
    {
      accessorKey: "title",
      header: t("Name"),
    },
    {
      accessorKey: "tagstring",
      header: t("Labels"),
      Cell: ({ row }) => (
        <div className="label-wrapper py-1">
          <div className="d-flex gap-2">
            <div
              className={
                row.original.tagstring !== ""
                  ? "label-container flex-grow-1"
                  : "d-none"
              }
            >
              <ul
                className="d-flex flex-wrap gap-2 m-0 p-0"
                style={{ listStyle: "none" }}
              >
                {row.original.tagstring.split(" , ").map((tag, index) => (
                  <li key={index} className="d-inline-flex">
                    <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                      <span className="badge-text fs-xs fw-medium me-1">
                        {tag}
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      ),
    },
    {
      accessorKey: "slug",
      header: t("Slug"),
    },
    {
      accessorKey: "moduleslug",
      header: t("Module"),
    },
    {
      accessorKey: "ownername",
      header: t("Owner"),
    },
    {
      accessorKey: "followersnames",
      header: t("Followers"),
    },
    {
      accessorKey: "createddate",
      header: t("Date Created"),
    },
  ];

  /*
   * Material React Table Column and States -----------------------------------------------------------
   *---------------------------------------------------------------------------------------------------
   */
  const columns = useMemo(
    () => initialTableColumns, //columns,
    [i18n.language],
  );

  const initialVisibilityState = initialTableColumns.reduce((acc, column) => {
    acc[column.accessorKey] = true;
    return acc;
  }, {});

  const [visibleColoumns, setVisibleColoumns] = useState(
    initialVisibilityState,
  );

  const onColumnVisiblityHandler = (newColumnState) => {
    const newColumnStateName = newColumnState();
    setVisibleColoumns((prev) => ({ ...prev, ...newColumnStateName }));
  };

  const initialColumnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];
  const [columnOrder, setColumnOrder] = useState(initialColumnOrder);

  const changeColumnOrderHandler = (changedOrder) =>
    setColumnOrder(changedOrder);

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key],
    );
    if (selectedIdsArray.length > 0) {
      setSelectProcessIds(selectedIdsArray);
    } else {
      setSelectProcessIds([]);
    }
  }, [rowSelection]);

  // Pagination save effect
  useEffect(() => {
    if (pagination.pageIndex > 0 || pagination.pageSize > 10) {
      setLastPagination({
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
      });
    }
  }, [pagination.pageIndex, pagination.pageSize]);

  // ✅ Single API trigger — fires only after filter popup has decided what to do.
  // jsonFilterQuery starts as null (popup not ready yet).
  // Popup sets it to [] (no default filter → fetch all) or [...] (has filters → fetch filtered).
  // This way only ONE api call happens — never two.
  useEffect(() => {
    if (jsonFilterQuery === null) return; // Popup hasn't responded yet, wait

    if (jsonFilterQuery.length > 0) {
      getAllProcess(jsonFilterQuery); // Filter query exists → filtered fetch
    } else {
      getAllProcess([]); // No filter → fetch all
    }

    setIsDataReady(true);
  }, [jsonFilterQuery]);

  // Reload effect — triggered by reset or refresh button
  useEffect(() => {
    if (reloadData) {
      setIsFilterReset(true);
      getAllProcess([]);
      setReloadData(false);
      setIsDataReady(true);
    }
  }, [reloadData]);

  //function for reset filter
  const resetFilterData = () => {
    setRowSelection({});
    setSelectProcessIds([]);
    setJsonFilterQuery(null); // reset to empty array (not null) — triggers fetch all
    setIsFilterReset(true);
    setReloadData(true);
  };

  const refreshRecords = () => {
    resetFilterData();
    columnReset();
  };

  const columnReset = () => {
    setVisibleColoumns(initialVisibilityState);
    setColumnOrder(initialColumnOrder);
  };

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    (moduleAccess.includes("MOD_CRM") && moduleAccess.includes("MOD_PROCESS"))
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderObject}
            activeOption={t("Activity Process")}
          />
          <div className="container-fluid px-5">
            <CRMProcessHeader
              reloadList={refreshRecords}
              selectProcessIds={selectProcessIds}
              jsonFilterQuery={jsonFilterQuery ?? []}
            />
            {/* ------------- table section ------------------ */}
            {isLoading || !isDataReady ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns} // map columns to be displayed with api data,
                  data={processList} // data from api to be displayed
                  enableGrouping
                  enableRowSelection
                  getRowId={(row) => `${row._id}-${row.email}`}
                  onRowSelectionChange={setRowSelection}
                  state={{
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }}
                  onPaginationChange={setPagination}
                  initialState={{
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }}
                  enableColumnOrdering={true}
                  onColumnVisibilityChange={onColumnVisiblityHandler}
                  onColumnOrderChange={changeColumnOrderHandler}
                  defaultColumn={{ minSize: 20, maxSize: 300, size: 50 }}
                  muiTableContainerProps={{ sx: { maxHeight: "60vh" } }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>
        </section>

        <ActivityProcessFilter
          moduleSlug="crmactivityprocess"
          visibleColoumns={visibleColoumns}
          setVisibleColoumns={setVisibleColoumns}
          columnOrder={columnOrder}
          setColumnOrder={setColumnOrder}
          setJsonFilterQuery={setJsonFilterQuery}
          reloadList={refreshRecords}
          isFilterReset={isFilterReset}
          setIsFilterReset={setIsFilterReset}
          columns={columns}
        />

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}

        <AddProcessFromTemplateModal
          moduleSlug={""}
          afterProcessModalClose={() => {
            setTimeout(() => {
              getAllProcess();
            }, 2000);
          }}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
        />

        {/* ----------- delete warning modal ------------ */}
        <DeleteWarningModal
          onCancelDelete={() => {
            setRowSelection({});
            setSelectProcessIds([]);
          }}
          onDelete={changeStatusHandler}
          moduleName={t("process")}
        />
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              {" "}
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};
export default CRMProcessBody;
